(function () {
  var DEBUG = false;

  if (window.stickyAtcLoaded) return;
  window.stickyAtcLoaded = true;

  function log() {
    if (DEBUG) console.log.apply(console, arguments);
  }

  function qs(selector, context) {
    return (context || document).querySelector(selector);
  }

  function qsa(selector, context) {
    return Array.prototype.slice.call(
      (context || document).querySelectorAll(selector)
    );
  }

  var stickyWrapper = qs('#sticky-atc-wrapper');
  var stickyBtn = qs('#sticky-atc-btn');
  var overlay = qs('#sticky-atc-overlay');
  var modal = qs('#sticky-atc-modal');
  var closeBtn = qs('#sticky-atc-close-btn');
  var confirmBtn = qs('#sticky-atc-confirm-btn');
  var sizeOptionsEl = qs('#sticky-atc-size-options');

  var findSizeBtn = qs('#sticky-atc-find-size-btn');
  var sizeGuideBtn = qs('#sticky-atc-size-guide-btn');
  var sizeSeparator = qs('.sticky-atc-size-separator');

  var mutationObserver = null;
  var isAddingToCart = false;

  function updateDynamicLinks() {
    var sizeBayBtn = document.getElementById('szb-vfr-button');
    var sizeMeasurementsBtn = document.getElementById(
      'szb-measurements-button'
    );

    if (findSizeBtn) {
      findSizeBtn.style.display = sizeBayBtn ? '' : 'none';
    }

    if (sizeGuideBtn) {
      sizeGuideBtn.style.display = sizeMeasurementsBtn ? '' : 'none';
    }

    if (sizeSeparator) {
      var findSizeVisible =
        findSizeBtn && findSizeBtn.style.display !== 'none';

      var sizeGuideVisible =
        sizeGuideBtn && sizeGuideBtn.style.display !== 'none';

      sizeSeparator.style.display =
        findSizeVisible && sizeGuideVisible ? '' : 'none';
    }
  }

  function getAddToCartButton() {
    var button = document.querySelector(
      '[data-block-type="buy-buttons"] form[action^="/cart/add"] buy-buttons button[type="submit"]'
    );

    if (button) return button;

    return document.querySelector(
      [
        'form[action^="/cart/add"] buy-buttons button[type="submit"]',
        'form[action^="/cart/add"] button[type="submit"]',
        'button[name="add"]',
        'button.product-form__submit'
      ].join(',')
    );
  }

  function toggleSticky() {
    if (!stickyWrapper) return;

    if (window.innerWidth >= 700) {
      stickyWrapper.classList.remove('is-visible', 'visible');
      document.body.classList.remove('sticky-atc-visible');
      return;
    }

    try {
      document.documentElement.style.setProperty(
        '--sticky-atc-height',
        (stickyWrapper.offsetHeight || 0) + 'px'
      );
    } catch (error) {
      log('No se pudo actualizar la altura del sticky', error);
    }

    stickyWrapper.classList.add('is-visible', 'visible');
    document.body.classList.add('sticky-atc-visible');
  }

  function getSelectedSize() {
    var checked = qs('input[name="sticky-atc-size"]:checked');
    return checked ? checked.value : null;
  }

  function escapeCssValue(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(value);
    }

    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function findOriginalInputByValue(value) {
    try {
      var escapedValue = escapeCssValue(value);

      var option2Input = document.querySelector(
        'input[name="option2"][value="' + escapedValue + '"]'
      );

      if (option2Input) return option2Input;

      var inputs = qsa('input[name^="option"]');
      var matchedInput = null;

      inputs.forEach(function (input) {
        if (input.value === value) {
          matchedInput = input;
        }
      });

      return matchedInput;
    } catch (error) {
      log('No se pudo localizar la talla original', error);
      return null;
    }
  }

  function isSizeOutOfStock(sizeValue) {
    try {
      var originalInput = findOriginalInputByValue(sizeValue);

      if (!originalInput) return false;
      if (originalInput.disabled) return true;

      var inputId = originalInput.getAttribute('id');

      var label = inputId
        ? document.querySelector(
            'label[for="' + escapeCssValue(inputId) + '"]'
          )
        : originalInput.closest('label');

      if (!label) return false;

      if (
        label.classList.contains('is-disabled') ||
        label.classList.contains('sold-out') ||
        label.classList.contains('disabled')
      ) {
        return true;
      }

      var styledNode = label.querySelector('span') || label;
      var computedStyle = window.getComputedStyle(styledNode);

      var textDecoration =
        computedStyle.textDecorationLine ||
        computedStyle.textDecoration ||
        '';

      return (
        typeof textDecoration === 'string' &&
        textDecoration.indexOf('line-through') !== -1
      );
    } catch (error) {
      log('No se pudo comprobar el stock', error);
      return false;
    }
  }

  function updateModalHeightVar() {
    if (!modal || !modal.classList.contains('active')) return;

    try {
      document.documentElement.style.setProperty(
        '--sticky-modal-height',
        (modal.offsetHeight || 0) + 'px'
      );
    } catch (error) {
      log('No se pudo actualizar la altura del modal', error);
    }
  }

  function updateButtonState() {
    if (!confirmBtn) return;

    var selectedSize = getSelectedSize();

    confirmBtn.disabled =
      !selectedSize || isSizeOutOfStock(selectedSize);

    confirmBtn.classList.remove('restock-mode');

    updateModalHeightVar();
    window.setTimeout(updateModalHeightVar, 50);
  }

  function updatePrice() {
    var stickyPriceEl = qs('.sticky-atc-price');

    var mainPriceEl = document.querySelector(
      ".product-info__block-item[data-block-type='price'] sale-price"
    );

    if (stickyPriceEl && mainPriceEl) {
      stickyPriceEl.innerHTML = mainPriceEl.innerHTML;
    }
  }

  function syncSizeToOriginal(selectedValue) {
    try {
      var originalInput = findOriginalInputByValue(selectedValue);

      if (!originalInput || originalInput.disabled) return false;

      var inputs = qsa(
        'input[name="' + escapeCssValue(originalInput.name) + '"]'
      );

      inputs.forEach(function (input) {
        input.checked = false;
      });

      originalInput.checked = true;

      originalInput.dispatchEvent(
        new Event('change', {
          bubbles: true
        })
      );

      window.setTimeout(updateButtonState, 100);

      return true;
    } catch (error) {
      log('Error sincronizando la talla', error);
      return false;
    }
  }

  function updateSizeOptionsState() {
    if (!sizeOptionsEl) return;

    var currentSize = getSelectedSize();
    var sizeOptions = qsa(
      '.sticky-atc-size-option',
      sizeOptionsEl
    );

    var originalSelected = qs('input[name="option2"]:checked');

    if (originalSelected && !currentSize) {
      currentSize = originalSelected.value;
    }

    sizeOptions.forEach(function (optionElement) {
      var input = qs('input', optionElement);
      var label = qs('label', optionElement);

      if (!input) return;

      var sizeValue = input.value;
      var outOfStock = isSizeOutOfStock(sizeValue);
      var isChecked = sizeValue === currentSize && !outOfStock;

      input.checked = isChecked;
      input.disabled = outOfStock;

      optionElement.classList.toggle('out-of-stock', outOfStock);

      if (label) {
  /*
   * No usamos las clases block-swatch ni is-disabled porque el tema
   * mexicano aplica estilos propios y duplica visualmente la talla.
   */
  label.classList.remove('block-swatch', 'is-disabled', 'sold-out', 'disabled');

  if (outOfStock) {
    label.setAttribute('aria-disabled', 'true');
  } else {
    label.removeAttribute('aria-disabled');
  }
}
    });

    updateButtonState();
  }

  function openSizeModal() {
    updateSizeOptionsState();
    updateDynamicLinks();

    if (mutationObserver) {
      mutationObserver.disconnect();
    }

    if (overlay) {
      overlay.classList.add('active');
      overlay.setAttribute('aria-hidden', 'false');
    }

    if (modal) {
  modal.style.display = 'flex';
  modal.setAttribute('aria-hidden', 'false');

  window.setTimeout(function () {
    modal.classList.add('active');
    updateModalHeightVar();

    if (sizeOptionsEl) {
      sizeOptionsEl.scrollTop = 0;
    }
  }, 10);
}

    document.body.classList.add('sticky-atc-modal-open');
    document.body.style.overflow = 'hidden';
  }

  function closeSizeModal() {
    if (modal) {
      modal.classList.remove('active');
      modal.setAttribute('aria-hidden', 'true');
    }

    if (overlay) {
      overlay.classList.remove('active');
      overlay.setAttribute('aria-hidden', 'true');
    }

    document.body.classList.remove('sticky-atc-modal-open');

    window.setTimeout(function () {
      if (modal) {
        modal.style.display = 'none';
      }

      document.body.style.overflow = '';

      if (mutationObserver) {
        mutationObserver.observe(document.documentElement, {
          childList: true,
          subtree: true
        });
      }
    }, 350);
  }

  function addToCart() {
    if (isAddingToCart) return;

    var selectedSize = getSelectedSize();

    if (!selectedSize) {
      window.alert('Por favor, selecciona una talla');
      return;
    }

    if (isSizeOutOfStock(selectedSize)) {
      return;
    }

    isAddingToCart = true;

    try {
      var synchronized = syncSizeToOriginal(selectedSize);

      if (!synchronized) {
        isAddingToCart = false;
        return;
      }

      window.setTimeout(function () {
        var addToCartButton = getAddToCartButton();

        if (!addToCartButton || addToCartButton.disabled) {
          isAddingToCart = false;
          return;
        }

        addToCartButton.click();

        window.setTimeout(function () {
          closeSizeModal();
          isAddingToCart = false;
        }, 600);
      }, 200);
    } catch (error) {
      log('Error añadiendo al carrito', error);
      isAddingToCart = false;
    }
  }

  if (stickyBtn) {
    stickyBtn.addEventListener('click', openSizeModal);
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', closeSizeModal);
  }

  if (overlay) {
    overlay.addEventListener('click', closeSizeModal);
  }

  if (confirmBtn) {
    confirmBtn.addEventListener('click', addToCart);
  }

  if (findSizeBtn) {
    findSizeBtn.addEventListener('click', function () {
      closeSizeModal();

      window.setTimeout(function () {
        var sizeBayButton = document.getElementById('szb-vfr-button');

        if (sizeBayButton) {
          sizeBayButton.click();
        }
      }, 400);
    });
  }

  if (sizeGuideBtn) {
    sizeGuideBtn.addEventListener('click', function () {
      closeSizeModal();

      window.setTimeout(function () {
        var measurementsButton = document.getElementById(
          'szb-measurements-button'
        );

        if (measurementsButton) {
          measurementsButton.click();
        }
      }, 400);
    });
  }

  if (sizeOptionsEl) {
    sizeOptionsEl.addEventListener('change', function (event) {
      var target = event.target;

      if (
        !target ||
        !target.matches('input[name="sticky-atc-size"]') ||
        target.disabled
      ) {
        return;
      }

      var selectedValue = target.value;

      syncSizeToOriginal(selectedValue);

      /*
       * Conserva el comportamiento de España:
       * seleccionar una talla disponible añade directamente al carrito.
       */
      window.setTimeout(function () {
        addToCart();
      }, 150);
    });

    sizeOptionsEl.addEventListener('click', function (event) {
      var label = event.target.closest('label');

      if (!label) return;

      var inputId = label.getAttribute('for');
      var input = inputId
        ? document.getElementById(inputId)
        : null;

      if (!input || input.disabled) {
        event.preventDefault();
        return;
      }

      if (input.checked) {
        addToCart();
      }
    });
  }

  document.addEventListener('change', function (event) {
    var target = event.target;

    if (
      target &&
      (
        target.matches('input[name="option2"]') ||
        target.matches('input[name^="option"]')
      )
    ) {
      updateSizeOptionsState();
      updateButtonState();
    }
  });

  document.addEventListener('variant:change', function () {
    window.setTimeout(function () {
      updatePrice();
      updateSizeOptionsState();
    }, 50);
  });

  var scrollTimeout;

  window.addEventListener('scroll', function () {
    window.clearTimeout(scrollTimeout);

    scrollTimeout = window.setTimeout(toggleSticky, 50);
  });

  window.addEventListener('resize', toggleSticky);
  window.addEventListener('orientationchange', toggleSticky);

  mutationObserver = new MutationObserver(function () {
    if (
      !document.body.classList.contains('sticky-atc-modal-open')
    ) {
      toggleSticky();
    }
  });

  mutationObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.setTimeout(toggleSticky, 200);

  window.setTimeout(function () {
    toggleSticky();
    updateDynamicLinks();
    updatePrice();
    updateSizeOptionsState();
  }, 1200);

  window.setTimeout(updateDynamicLinks, 3000);
  window.setTimeout(updateDynamicLinks, 6000);

  log('Sticky CTA México listo');
})();